const statusChangeReason = {
  enable: "InstantPay enabled through facility drawer.",
  prohibit: "InstantPay prohibited through facility drawer.",
};

export { statusChangeReason };
